import React, { Component, PropTypes } from 'react';
import { debounce, each, unionWith, isEqual, remove, uniqueId } from 'lodash';
import axios from 'axios';
import baseUrl from '../../../utils/baseUrl';
import { Link } from 'react-router';

import Spinner from '../../svg/spinner';

import css from './tagselect.scss';

// import { VALIDATE_URL } from '../validate';
// import searchIcon from './icon-search.png';

export default class InputTagSelect extends Component {
	static propTypes = {
		value: PropTypes.string.isRequired,
		placeholder: PropTypes.string,
		path: PropTypes.string,
		maxSelected: PropTypes.number.isRequired,
		canDelete: PropTypes.bool.isRequired,
		onChange: PropTypes.func.isRequired,
		link: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.shape({
				url: PropTypes.string.isRequired,
				text: PropTypes.string.isRequired,
			}),
		]),
		mainClass: PropTypes.string,
		showLink: PropTypes.bool,
		createEnabled: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.string,
		]).isRequired,
	};

	static defaultProps = {
		value: '[]',
		placeholder: '',
		maxSelected: 0,
		canDelete: true,
		link: false,
		showLink: false,
		onChange: () => {},
		createEnabled: false,
	};

	constructor(props) {
		super(props);

		this.DEBUG = true;

		this.value = JSON.parse(props.value);

		this.search = debounce(this.search.bind(this), 500);

		this.state = {
			waiting: false,
			value: this.value,
			results: [],
			showResults: false,
			inputValue: '',
		};
	}

	shouldComponentUpdate() {
		return true;
	}

	render() {
		const regex = new RegExp(`^(.*?)(${(this.state.inputValue.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'))})(.*?)$`, 'i');
		const results = [];

		let mainClass = 'span3 span5-tablet span11-mobile form-tagselect';
		const taglistClass = 'form-tagselect__taglist';
		let tagsearchClass = 'form-tagselect__tagsearch';
		const tagresultClass = 'form-tagselect__tagresult';
		let tagresultItemClass = 'form-tagselect__tagresult__item';
		let resultLength = this.state.results.length;

		if (this.state.showResults && this.props.link && this.props.showLink) {
			resultLength++;
		}

		if (this.props.createEnabled) {
			resultLength++;
		}

		let tagResultStyles = {
			height: `${(this.state.showResults ? ((resultLength * 41) + 1) : 0)}px`,
		};

		if (this.props.mainClass) {
			mainClass += ` ${this.props.mainClass}`;
		}

		each(this.state.results, (obj) => {
			if (regex.test(obj.name)) {
				const newObj = { ...obj };
				newObj.parts = regex.exec(obj.name);
				results.push(newObj);
			}
		});

		return (
			<div className={mainClass}>
				<ol className={`${taglistClass} ${(this.state.value.length ? `${taglistClass}--active ` : '')}`}>
					{this.state.value.map((item) => (
						<InputTagSelectItem
							key={item.id || item.fid}
							delete={(obj) => this.delete(obj)}
							item={item}
							canDelete={this.props.canDelete}
						/>
					))}
				</ol>

				<div className={tagsearchClass}>
					{this.state.waiting && (<Spinner className={`${tagsearchClass}__waiting`} size='18px' />)}

					<input
						type='text'
						ref='input'
						value={this.state.inputValue}
						placeholder={this.props.placeholder}
						className={
							`${tagsearchClass}__input ${((this.state.showResults) ? `${tagsearchClass}__input--search-active` : '')}`
						}
						disabled={!(!this.props.maxSelected || this.state.value.length < this.props.maxSelected)}
						onInput={(e) => this.inputChange(e)}
						onFocus={() => this.showResult()}
					/>

					{this.state.showResults && (
						<div className={`${tagresultClass}__dimmer`} onClick={() => this.hideResults()}></div>
					)}

					<div className={`${tagresultClass} ${((this.state.showResults) ? `${tagresultClass}--active` : '')}`} style={tagResultStyles}>
						<ol className={`${tagresultClass}__list`}>
							{results.map((item, i) => (
								<li key={i} className={tagresultItemClass} onClick={() => this.add(item)}>
									<span>{item.parts[1]}</span>
									<span className='highlight'>{item.parts[2]}</span>
									<span>{item.parts[3]}</span>
								</li>
							))}

							{(!!this.props.createEnabled) && (
								<li className={`${tagresultItemClass} pixel-pattern`}>
									<a href='#' onClick={() => this.createEntry()}>
										{this.props.createEnabled}
										<div className='icon-plus'></div>
									</a>
								</li>
							)}

							{(!!this.props.link && this.props.showLink) && (
								<li className={`${tagresultItemClass} pixel-pattern`}>
									<Link
										to={this.props.link.url}
										target='_blank' onClick={(e) => {
											this.props.link.onClick && this.props.link.onClick(e, this.state.inputValue, (...args) => this.createEntry.apply(this, args));
											this.hideResults();
										}}
									>
										{this.props.link.text}
										<div className='icon-plus'></div>
									</Link>
								</li>
							)}
						</ol>
					</div>
				</div>

			</div>
		);
	}

	createEntry(data = {}) {
		const item = {
			id: false,
			fid: uniqueId('t'),
			...data,
			name: this.state.inputValue,
		};

		this.add(item);
	}

	inputChange(e) {
		this.setState({
			...this.state,
			waiting: true,
			inputValue: e.target.value,
		});

		this.search();
	}

	showResult() {
		if (this.state.inputValue) {
			this.setState({
				...this.state,
				showResults: true,
			});
		}
	}

	hideResults() {
		this.setState({
			...this.state,
			showResults: false,
		});
	}

	search() {
		const handleResult = (result) => {
			const newResult = remove(result, (item) => {
				for (let i = 0; i < this.state.value.length; i++) {
					if (this.state.value[i].id === item.id) {
						return false;
					}
				}
				return true;
			});
			this.setState({
				...this.state,
				waiting: false,
				showResults: !!newResult.length || !!this.props.link,
				results: !!newResult.length ? newResult : this.state.results,
			});
		};

		this.searchApi(this.state.inputValue)
		.then((result) => handleResult(result))
		.catch((result) => handleResult(result));
	}

	delete(item) {
		const newValue = [...this.state.value];
		remove(newValue, (o) => ((item.id && item.id === o.id) || (item.fid && item.fid === o.fid)));

		this.setState({
			...this.state,
			value: newValue,
		});

		this.onChange(newValue);
	}

	add(item) {
		const newValue = unionWith(this.state.value, [item], isEqual);

		this.setState({
			...this.state,
			value: newValue,
			showResults: false,
			inputValue: '',
		});

		this.onChange(newValue);
	}

	onChange(value) {
		const cleanValue = [];

		// make a new array with only the needed values
		// used for serializing the form later, so we want it clean
		for (let i = 0; i < value.length; i++) {
			cleanValue[i] = {};
			const keys = Object.keys(value[i]);
			for (let k = 0; k < keys.length; k++) {
				const key = keys[k];
				if (key === 'id' || key === 'name' || key === 'myProfile') {
					cleanValue[i][key] = value[i][key];
				}
			}
		}

		this.value = cleanValue;
		this.props.onChange({ value: cleanValue });
	}

	searchApi(query) {
		let results = [];

		return new Promise((resolve, reject) => {
			if (!query.length) {
				reject(results);
			}

			axios.get(
				baseUrl + this.props.path,
				{
					params: {
						q: query,
						limit: 8,
					},
				}
			)
			.then((response) => {
				if (response.data && response.data.result && response.data.result.length) {
					results = response.data.result;
				}

				resolve(results);
			})
			.catch(() => {
				reject(results);
			});
		});
	}
}

class InputTagSelectItem extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		delete: PropTypes.func.isRequired,
		canDelete: PropTypes.bool.isRequired,
		mainClass: PropTypes.string,
	};

	static defaultProps = {
		canDelete: true,
		mainClass: '',
		delete: () => {},

	};

	constructor() {
		super();

		this.timer = 0;

		this.state = {
			animateIn: true,
			animateOut: false,
		};
	}

	shouldComponentUpdate() {
		return true;
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	render() {
		let mainClass = 'form-tagselect__taglist__item';
		let innerClass = 'form-tagselect__taglist__item-inner';

		if (this.props.mainClass) {
			mainClass += ` ${this.props.mainClass}`;
		}

		if (this.state.animateIn) {
			this.timer = setTimeout(() => {
				this.setState({
					...this.state,
					animateIn: false,
				});
			}, 10);
		}

		if (!this.props.canDelete) {
			innerClass += ' form-tagselect__taglist__item-inner--no-delete';
		}

		return (
			<li className={mainClass + ((!this.state.animateIn && !this.state.animateOut) ? ' form-tagselect__taglist__item--show' : '')} onClick={() => this.delete()} >
				<div className={innerClass}>
					{this.props.item.name}
					{(this.props.item.fid) && (
						<span className='form-tagselect__taglist__capsule'>
							{this.props.item.myProfile ? 'New Profile' : 'New Credit'}
						</span>
					)}
				</div>
			</li>
		);
	}

	delete() {
		if (!this.props.canDelete) {
			return false;
		}

		if (typeof this.props.item.onDelete === 'function') {
			this.props.item.onDelete();
		}

		this.setState({
			...this.state,
			animateOut: true,
		});

		setTimeout(() => {
			this.props.delete(this.props.item);
		}, 300);

		return true;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/tagselect/tagselect.js
 **/